import * as React from "react";
import { Grid, Paper, Typography } from "@mui/material";

interface EmptyStateProps {
  label?: string;
}

export default function EmptyState(props: EmptyStateProps) {
  return (
    <Grid sx={{ textAlign: "center", mt: 4, justifySelf: "center" }}>
      <Paper
        elevation={0}
        sx={{
          display: "inline-flex",
          borderRadius: "12px",
          backgroundColor: "transparent",
          p: 0,
          overflow: "hidden",
        }}
      >
        <img
          src="../emptyStatePets.gif"
          width={300}
          height={200}
          style={{
            borderRadius: "12px",
            objectFit: "contain",
          }}
        />
      </Paper>
      <Typography
        variant="h6"
        gutterBottom
        align="center"
        color="text.secondary"
      >
        {props.label ?? "Nada por aqui!"}
      </Typography>
    </Grid>
  );
}
